import { render, staticRenderFns } from "./OrgAlertMsgsModal.vue?vue&type=template&id=2d5f29ab&"
import script from "./OrgAlertMsgsModal.vue?vue&type=script&lang=ts&"
export * from "./OrgAlertMsgsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports